import React, { useMemo } from 'react';
import useModelHubStore, { SORT_OPTIONS } from '../store/useModelHubStore';
import { TYPE_FILTERS, ownerHue } from '../hubMeta';
import HubDropdown from './HubDropdown';

const HubToolbar = ({ owners, totalCount }) => {
  const {
    searchTerm,
    setSearchTerm,
    activeTypes,
    toggleType,
    setActiveTypes,
    sortBy,
    setSortBy,
    ownerFilter,
    setOwnerFilter,
  } = useModelHubStore();

  const ownerOptions = useMemo(
    () => [
      { value: '', label: 'All owners', count: totalCount },
      ...owners.map((o) => ({
        value: o.id,
        label: o.name,
        count: o.count,
        hue: ownerHue(o.id || o.name),
      })),
    ],
    [owners, totalCount],
  );

  // One owner means nothing to choose between — but a filter left over from an
  // earlier visit (the store outlives the page) must stay clearable from here.
  const showOwnerFilter = owners.length > 1 || !!ownerFilter;

  return (
    <div className="hub-toolbar">
      <div className="hub-toolbar__search">
        <i className="fa fa-search hub-toolbar__search-icon" aria-hidden />
        <input
          type="text"
          className="hub-toolbar__search-input"
          placeholder="Search models by name, description or tag…"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          aria-label="Search models"
        />
        {searchTerm && (
          <button
            type="button"
            className="hub-toolbar__search-clear"
            onClick={() => setSearchTerm('')}
            aria-label="Clear search"
          >
            <i className="fa fa-times" aria-hidden />
          </button>
        )}
      </div>

      <div className="hub-toolbar__row">
        <div className="hub-toolbar__chips" role="group" aria-label="Filter by task type">
          <button
            type="button"
            className={`hub-chip${activeTypes.length === 0 ? ' hub-chip--active' : ''}`}
            onClick={() => setActiveTypes([])}
            aria-pressed={activeTypes.length === 0}
          >
            All
          </button>
          {TYPE_FILTERS.map((t) => {
            const active = activeTypes.includes(t.value);
            return (
              <button
                key={t.value}
                type="button"
                className={`hub-chip${active ? ' hub-chip--active' : ''}`}
                onClick={() => toggleType(t.value)}
                aria-pressed={active}
              >
                <i className={`fa ${t.icon}`} aria-hidden />
                {t.label}
              </button>
            );
          })}
        </div>

        <div className="hub-toolbar__controls">
          {showOwnerFilter && (
            <HubDropdown
              icon="fa-user"
              label="All owners"
              ariaLabel="Filter by owner"
              searchPlaceholder="Search owners…"
              value={ownerFilter}
              options={ownerOptions}
              onChange={setOwnerFilter}
              active={!!ownerFilter}
            />
          )}
          <HubDropdown
            icon="fa-sort-amount-down"
            label="Sort"
            ariaLabel="Sort models"
            value={sortBy}
            options={SORT_OPTIONS}
            onChange={setSortBy}
            searchable={false}
            minWidth={180}
          />
        </div>
      </div>
    </div>
  );
};

export default HubToolbar;
